import { IconButton, styled } from '@mui/material';

const StyledSessionDetailsDialogCloseButton = styled(IconButton)(({ theme }) => ({
  padding: theme.spacing(0.5)
}));

export default StyledSessionDetailsDialogCloseButton;
